/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Button } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import Grid from '@mui/joy/Grid';
//import { Col, Row } from 'react-bootstrap';

// Components
import TextInput from 'components/input/textInput';
import DatePickerInput from 'components/input/DatePicker';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { HtmlTooltip } from 'screen/selectCollege/SelecCollegePage';
import { Typography } from '@mui/material';
import GroupCheckbox from 'components/input/GroupCheckbox';
import CheckboxInput from 'components/input/CheckboxInput';
import SelectInput from 'components/input/SelectInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import HighSchoolInfo from './HighSchoolInfo';
import DateReceiveInfo from './DateReceiveInfo';
import { displayHighSchoolName } from '../highSchoolSearch';

// Utilities and Config
import {
  checkDecimalInRange,
  checkEnableParseJSON,
  optionValues2,
  schoolGradingScaleOptions,
} from 'components/helper/helper';
import { useAppDispatch } from 'app/hooks';
import { getGradeAndCourse, updateGradeAndCourse } from 'app/course/courseSlice';
import { gradeOptions } from './education.config';
import { getAccessToken, getUserId } from 'utils/sessionStorage';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const initialSchoolValues = {
  where_attend_high_school: 'IN_CA',
  state: '',
  city: '',
  country: '',
  is_home_school: false,
  is_independant_study: false,
  my_home_school_associated_with_high_school: false,
  school_name: '',
  school_type: '',
  high_school_name: '',
  high_school_code: '',
  start_date: moment().toISOString(),
  end_date: moment().add(1, 'M').toISOString(),
  degree: '',
  month: '',
  day: '',
  year: '',
  grade: [],
  academic_year: [],
  is_summer_took: [],
  specialized_curriculum_career: false,
  specialized_curriculum_international: false,
  specialized_curriculum_magnet: false,
  specialized_curriculum_other: false,
  specialized_curriculum_other_free_text: '',
  grading_scale: '',
  grading_scale_is_abcdf: false,
  grading_scale_is_0_100: false,
  grading_scale_is_1_7: false,
  grading_scale_is_other: false,
  is_block_scheduling: false,
  degreeFreeText: '',
  lowest_number_grade: '',
  highest_number_grade: '',
  classes_schedule: '',
  other_grading_system: '',
  graduating_high_school: '',
  school_term_1: false,
  school_term_2: false,
  school_term_3: false,
  school_term_4: false,
  high_school_object: {
    college_board_code: '',
    school_name: '',
    school_type: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    csu_name: '',
    uc_name: '',
    cm_name: '',
    match_all: false,
    label: '',
    code: null,
    is_manual: false,
  },
  is_boarding_school: '',
  is_graduate_from_this_school: '',
  is_live_on_campus: '',
  graduation_status: '',
  academic_performance: '',
  name_of_degree: '',
  allNoneAGCourses: false,
  have_other_grading_system: 'false',
  second_grading_system: '',
  gradeIsNew: [],
};

const initItem = (item: any) => {
  try {
    if (item) {
      //console.log('item.degree : ' ,item.degree );
      return {
        where_attend_high_school: item.where_attend_high_school ?? 'IN_CA',
        state: item?.state ?? '',
        city: item?.city ?? '',
        country: item?.country ?? '',
        is_home_school: item?.is_home_school ?? false,
        is_independant_study: item?.is_independant_study ?? false,
        my_home_school_associated_with_high_school:
          item?.my_home_school_associated_with_high_school ?? false,
        school_name: item?.school_name ?? '',
        school_type: item?.school_type ?? '',
        high_school_name: item?.high_school_name ?? '',
        high_school_code: item?.high_school_code ?? '',
        start_date: item?.start_date ?? moment().toISOString(),
        end_date: item?.end_date ?? moment().add(1, 'M').toISOString(),
        degree: item?.degree ?? '',
        month: item?.month ?? '',
        day: item?.day ?? '',
        year: item?.year ?? '',
        grade: [...(item?.grade ?? [])],
        academic_year: [...(item?.academic_year ?? [])],
        is_summer_took: [...(item?.is_summer_took ?? [])],
        specialized_curriculum_career: item?.specialized_curriculum_career ?? false,
        specialized_curriculum_international: item?.specialized_curriculum_international ?? false,
        specialized_curriculum_magnet: item?.specialized_curriculum_magnet ?? false,
        specialized_curriculum_other: item?.specialized_curriculum_other ?? false,
        specialized_curriculum_other_free_text: item?.specialized_curriculum_other_free_text ?? '',
        grading_scale: item?.grading_scale ?? '',
        grading_scale_is_abcdf: item?.grading_scale_is_abcdf ?? false,
        grading_scale_is_0_100: item?.grading_scale_is_0_100 ?? false,
        grading_scale_is_1_7: item?.grading_scale_is_1_7 ?? false,
        grading_scale_is_other: item?.grading_scale_is_other ?? false,
        is_block_scheduling: item?.is_block_scheduling ?? false,
        degreeFreeText: item?.degreeFreeText ?? '',
        lowest_number_grade: item?.lowest_number_grade ?? '',
        highest_number_grade: item?.highest_number_grade ?? '',
        classes_schedule: item?.classes_schedule ?? '',
        other_grading_system: item?.other_grading_system ?? '',
        graduating_high_school: item?.graduating_high_school ?? '',
        school_term_1: item?.school_term_1 ?? false,
        school_term_2: item?.school_term_2 ?? false,
        school_term_3: item?.school_term_3 ?? false,
        school_term_4: item?.school_term_4 ?? false,
        high_school_object: item?.high_school_object ?? {
          college_board_code: '',
          school_name: '',
          school_type: '',
          city: '',
          state: '',
          zip: '',
          country: '',
          csu_name: '',
          uc_name: '',
          cm_name: '',
          match_all: false,
          label: '',
          code: null,
          is_manual: false,
        },
        is_boarding_school: item?.is_boarding_school ?? '',
        is_graduate_from_this_school: item?.is_graduate_from_this_school ?? '',
        is_live_on_campus: item?.is_live_on_campus ?? '',
        graduation_status: item?.graduation_status ?? '',
        academic_performance: item?.academic_performance ?? '',
        name_of_degree: item?.name_of_degree ?? '',
        allNoneAGCourses: item?.allNoneAGCourses ?? false,
        have_other_grading_system: item?.have_other_grading_system ?? 'false',
        second_grading_system: item?.second_grading_system ?? '',
        gradeIsNew: [...(item?.gradeIsNew ?? [])],
      };
    }
  } catch (ex) {
    console.log('Error:', ex);
  }
  return initialSchoolValues;
};

interface Props {
  handleSave: (value: any) => void;
  item: any;
  index: number;
  indexText: string;
  onRemove: () => void;
  handleCheckCurrent: (name: string) => void;
  expandAll?: boolean;
  handleExpandActive: (value: any) => void;
  check?: any;
  indexExpand?: any;
  disabled?: boolean;
}

const SchoolConfig = (props: Props) => {
  const dispatch: any = useAppDispatch();

  // State Management
  const [expanded, setExpanded] = React.useState(props.expandAll || false);
  //const [isInitialized, setIsInitialized] = React.useState(false);
  const [isInitialized] = React.useState(false);
  
  const [gradeCourse, setGradeCourse] = React.useState<any>({});
  const [grade9Course, setGrade9Course] = React.useState<any>([]);
  const [grade10Course, setGrade10Course] = React.useState<any>([]);
  const [grade11Course, setGrade11Course] = React.useState<any>([]);
  const [grade12Course, setGrade12Course] = React.useState<any>([]);
  const [academicYearOptions, setAcademicYearOptions] = React.useState<any[]>([]);
  const [pendingUpdates, setPendingUpdates] = React.useState(false);
  const elementRef = React.useRef<HTMLDivElement>(null);
  const gradingScaleSyncReady = React.useRef(false);
  const MIN_YEAR = 1990;

  const validationSchema = Yup.object().shape({
    start_date: Yup.string()
      .nullable()
      .required('Start Date is required')
      .test('is-valid-date', 'Invalid date', function (value: any) {
        if (!value) {
          return false;
        }

        let year = moment(value).format('yyyy');
        if (Number(year) < MIN_YEAR) return false;

        return moment(value).isValid();
      }),
    end_date: Yup.string()
      .nullable()
      .required('End Date is required')
      .test('is-valid-date', 'Invalid date', function (value: any) {
        if (!value) {
          return false;
        }
        let year = moment(value).format('yyyy');
        if (Number(year) < MIN_YEAR) return false;
        return moment(value).isValid();
      })
      .test('is-after-start-date', 'Start Date cannot be before End Date', function (value) {
        const { start_date } = this.parent;
        return moment(value).isAfter(moment(start_date));
      }),
    classes_schedule: Yup.string().required('This field is required'),
    is_boarding_school: Yup.string().required('This field is required'),
    is_live_on_campus: Yup.string().required('This field is required'),
    is_graduate_from_this_school: Yup.string().required('This field is required'),
    grade: Yup.array().of(Yup.string().required('Grade is required')),
    academic_year: Yup.array().of(Yup.string().required('This field is required')),
    degree: Yup.string().required('This field is required'),
    month: Yup.string()
      .required('Month is required')
      .when('degree', {
        is: (degree: string) => degree !== 'No degree from this high school',
        then: Yup.string().test('is-month-required', 'Month is required', function (value) {
          return value !== '' && value !== '- Select -';
        }),
      }),
    day: Yup.string().when('degree', {
      is: (degree: string) => degree !== 'No degree from this high school',
      then: Yup.string()
        .required('Day is required')
        .test('is-day-required', 'Day is required', function (value) {
          return value !== '' && value !== '- Select -';
        }),
    }),
    year: Yup.string()
      .required('Year is required')
      .when('degree', {
        is: (degree: string) => degree !== 'No degree from this high school',
        then: Yup.string().test('is-year-required', 'Year is required', function (value) {
          return value !== '' && value !== '- Select -';
        }),
      }),
  });

  // Form initialization
  const formItem = useFormik({
    initialValues: initItem(props.item),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      props.handleSave({ ...values });
    },
  });

  let gradeCourseData = {
    lastIndex: null,
    schoolName: '',
    schoolCode: '',
    CMGradingScale: '',
    CNGradingScale: '',
    grade: [],
    finalGrade: '',
    credits: [],
    finalCredits: '',
    checkedNA: false,
    otherGradeScale: '',
    subject: '',
    courseName: '',
    class: '',
    otherClass: '',
    schedule: '',
    otherSchedule: '',
    schedule_transcript: '',
    isFirstSemester: false,
    isSecondSemester: false,
    isThirdSemester: false,
    isFourthSemester: false,
    isTakeIn678Grade: false,
    isUsedBlockScheduling: false,
    classOccurredDuringGrade: '',
    typeOfClass: '',
    isTakeClassAtCollege: false,
    collegeTookClass: '',
    subjectDetails: [],
    number_of_summer_courses: 0,
    have12thGradeCourses: '',
    allNoneAGCourses: true,
    schoolYear: '',
    classOccurredDuringTime: 'Regular academic year',
  };
  // Utility functions
  const getCMGradingScale = () => {
    if (formItem.values.grading_scale_is_abcdf) return 'A-F';
    if (formItem.values.grading_scale_is_0_100) return '0-100';
    if (formItem.values.grading_scale_is_1_7) return '1-7';
    return 'Other';
  };

  console.log('pendingUpdates:', formItem.values);
  React.useEffect(() => {
    try {
      if (
        moment(formItem.values.start_date).isValid() &&
        moment(formItem.values.end_date).isValid()
      ) {
        let fromYear = moment(formItem.values.start_date).format('yyyy');
        if (Number(fromYear) < MIN_YEAR) return;

        let toYear = moment(formItem.values.end_date).format('yyyy');
        if (Number(toYear) < MIN_YEAR) return;

        let fromDateYear = Number(fromYear);
        let toDateYear = Number(toYear);
        if (fromYear && toDateYear) {
          let dateRange = toDateYear - fromDateYear;
          if (dateRange === 0) {
            // Same calendar year: course could fall in either of the two academic years that include this year
            const arr = [
              { value: `${fromDateYear - 1} - ${fromDateYear}` },
              { value: `${fromDateYear} - ${fromDateYear + 1}` },
            ];
            setAcademicYearOptions(['', ...arr]);
          } else if (dateRange > 0) {
            const arr = optionValues2(dateRange).map((item) => {
              return { value: `${item.value + fromDateYear} - ${item.value + fromDateYear + 1}` };
            });
            setAcademicYearOptions(['', ...arr]);
          }
        }
      }
    } catch (ex) {
      console.log('Error: ', ex);
    }
  }, [formItem.values.start_date, formItem.values.end_date]);

  //second_grading_system_options =
  const classes_schedule_options = [
    'Full year (1 final grade per year)',
    'Semester (2 final grades per year)',
    'Trimester (3 final grades per year)',
    'Quarter (4 final grades per year)',
  ];

  const getScheduleFormat = (classes_schedule: string) => {
    switch (classes_schedule) {
      case 'Full year (1 final grade per year)':
        return 'Yearly';
      case 'Semester (2 final grades per year)':
        return 'Semester';
      case 'Trimester (3 final grades per year)':
        return 'Trimester';
      case 'Quarter (4 final grades per year)':
        return 'Quarters';
      default:
        return 'Semester';
    }
  };

  // Hàm cập nhật đồng bộ tất cả các thay đổi cho tất cả grade
  const updateAllGradeCourses = () => {
    const studentId = getUserId();
    if (!studentId || !gradeCourse?.student_id) return;

    // Tạo bản sao của các mảng hiện tại để tránh thay đổi trực tiếp state
    const updatedGrade9 = [...grade9Course];
    const updatedGrade10 = [...grade10Course];
    const updatedGrade11 = [...grade11Course];
    const updatedGrade12 = [...grade12Course];
    let hasChanges = false;

    // Xử lý từng giá trị grade
    formItem.values.grade.forEach((gradeValue, index) => {
      if (gradeValue && gradeValue !== '- Select -' && gradeValue !== '') {
        let academicYear = formItem.values.academic_year[index];
        if (!academicYear || academicYear === '- Select -' || academicYear === '') return;

        // Chuẩn bị dữ liệu chung
        let commonData = {
          ...gradeCourseData,
          schoolName: formItem.values.high_school_name,
          schoolYear: String(academicYear).replace(' - ', '-'),
          CMGradingScale: getCMGradingScale(),
          schedule: getScheduleFormat(formItem.values.classes_schedule),
          student_id: studentId,
          classOccurredDuringGrade: `${gradeValue} Grade`,
          schoolCode: formItem.values.high_school_code,
        };

        // Cập nhật mảng tương ứng dựa trên grade
        if (gradeValue === '9th') {
          let index9 = updatedGrade9.findIndex(
            (item: any) => item.schoolName === commonData.schoolName
          );

          if (index9 >= 0) {
            updatedGrade9[index9] = {
              ...updatedGrade9[index9],
              ...commonData,
              subjectDetails: updatedGrade9[index9]?.subjectDetails,
            };
          } else {
            updatedGrade9.push(commonData);
          }
          hasChanges = true;
        } else if (gradeValue === '10th') {
          let index10 = updatedGrade10.findIndex(
            (item: any) => item.schoolName === commonData.schoolName
          );

          if (index10 >= 0) {
            updatedGrade10[index10] = {
              ...updatedGrade10[index10],
              ...commonData,
              subjectDetails: updatedGrade10[index10]?.subjectDetails,
            };
          } else {
            updatedGrade10.push(commonData);
          }
          hasChanges = true;
        } else if (gradeValue === '11th') {
          let index11 = updatedGrade11.findIndex(
            (item: any) => item.schoolName === commonData.schoolName
          );

          if (index11 >= 0) {
            updatedGrade11[index11] = {
              ...updatedGrade11[index11],
              ...commonData,
              subjectDetails: updatedGrade11[index11]?.subjectDetails,
            };
          } else {
            updatedGrade11.push(commonData);
          }
          hasChanges = true;
        } else if (gradeValue === '12th') {
          let index12 = updatedGrade12.findIndex(
            (item: any) => item.schoolName === commonData.schoolName
          );

          if (index12 >= 0) {
            updatedGrade12[index12] = {
              ...updatedGrade12[index12],
              ...commonData,
              subjectDetails: updatedGrade12[index12]?.subjectDetails,
            };
          } else {
            updatedGrade12.push(commonData);
          }
          hasChanges = true;
        }
      }
    });

    // Chỉ cập nhật state và gọi API nếu có thay đổi
    if (hasChanges) {
      // Cập nhật state local
      setGrade9Course(updatedGrade9);
      setGrade10Course(updatedGrade10);
      setGrade11Course(updatedGrade11);
      setGrade12Course(updatedGrade12);

      // Tạo object mới để cập nhật database
      const updatedGradeCourse = {
        ...gradeCourse,
        grade_9_course_array: JSON.stringify(updatedGrade9),
        grade_10_course_array: JSON.stringify(updatedGrade10),
        grade_11_course_array: JSON.stringify(updatedGrade11),
        grade_12_course_array: JSON.stringify(updatedGrade12),
        silent: true,
      };

      // Cập nhật state và gọi API một lần duy nhất
      setGradeCourse(updatedGradeCourse);
      dispatch(updateGradeAndCourse(updatedGradeCourse));
    }
  };

  // Event handlers
  const handleExpandClick = () => {
    setExpanded(!expanded);
    props.handleExpandActive(expanded);
  };

  const handleSave = () => {
    try {
      if (!checkDecimalInRange(formItem.values.highest_number_grade)) {
        formItem.setFieldError('highest_number_grade', 'Invalid number');
      } else if (!checkDecimalInRange(formItem.values.lowest_number_grade)) {
        formItem.setFieldError('lowest_number_grade', 'Invalid number');
      } else {
        props.handleSave({
          ...formItem.values,
        });

        setTimeout(() => {
          const hasValidGrade = formItem.values.grade.some(
            (g) => g && g !== '- Select -' && g !== ''
          );
          // const hasValidAcademic = formItem.values.academic_year.some(
          //   (a) => a && a !== '- Select -' && a !== ''
          // );

          if (
            hasValidGrade
            //  &&
            // hasValidAcademic &&
            // formItem.values.high_school_name &&
            // (formItem.values.classes_schedule || pendingUpdates)
          ) {
            updateAllGradeCourses();
            setPendingUpdates(false);
          }
        }, 500);

        // clearTimeout(handleSave);

        setExpanded(false);
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  const handleAddTerm = () => {
    if (formItem.values.grade.length >= 4) {
      console.log('Maximum 4 terms reached!');
      return;
    }

    const newGrade = [...formItem.values.grade, ''];
    const newAcademicYear = [...formItem.values.academic_year, ''];
    const newIsSummerTook = [...formItem.values.is_summer_took, false];

    // Create a new gradeIsNew entry
    const currentGradeIsNew = formItem.values.gradeIsNew || [];
    const newGradeIsNew = [
      ...currentGradeIsNew,
      {
        grade: '',
        academicYear: '',
        isNew: true,
        schoolName: formItem.values.high_school_name,
        grading_scale_is_abcdf: formItem.values.grading_scale_is_abcdf,
        grading_scale_is_0_100: formItem.values.grading_scale_is_0_100,
        grading_scale_is_1_7: formItem.values.grading_scale_is_1_7,
        grading_scale_is_other: formItem.values.grading_scale_is_other,
      },
    ];

    formItem.setFieldValue('grade', newGrade);
    formItem.setFieldValue('academic_year', newAcademicYear);
    formItem.setFieldValue('is_summer_took', newIsSummerTook);
    formItem.setFieldValue('gradeIsNew', newGradeIsNew);
  };

  const handleRemoveTerm = (index: any) => {
    formItem.setFieldValue(
      'grade',
      formItem.values.grade.filter((_, i) => i !== index)
    );
    formItem.setFieldValue(
      'academic_year',
      formItem.values.academic_year.filter((_, i) => i !== index)
    );
    formItem.setFieldValue(
      'is_summer_took',
      formItem.values.is_summer_took.filter((_, i) => i !== index)
    );

    // Also update gradeIsNew
    if (formItem.values.gradeIsNew && formItem.values.gradeIsNew.length > 0) {
      formItem.setFieldValue(
        'gradeIsNew',
        formItem.values.gradeIsNew.filter((_, i) => i !== index)
      );
    }

    // Đánh dấu cần cập nhật
    setPendingUpdates(true);
  };

  const buildHeader = () => {
    let title =
      (displayHighSchoolName(formItem.values) || formItem.values.high_school_name || '') +
      (props.indexText.slice(0, 1) === '1'
        ? ' - Current or Most Recent High School'
        : ' - Other High School');
    const details = [];

    if (formItem.values.start_date) {
      details.push(moment(formItem.values.start_date).format('MM/YYYY'));
    } else {
      details.push('/');
    }

    if (formItem.values.end_date) {
      details.push(moment(formItem.values.end_date).format('MM/YYYY'));
    } else {
      details.push('/');
    }

    if (!details.length) {
      return title;
    }

    return `${title} - ${details.join(' to ')}`;
  };

  // API calls and data fetching
  const getGradeAndCourseFnc = async () => {
    const studentId = getUserId();
    const token = getAccessToken();

    if (studentId && token) {
      try {
        const res = await dispatch(getGradeAndCourse(studentId));
        const dataLoaded = res.payload;

        if (dataLoaded) {
          const grade9 = checkEnableParseJSON(dataLoaded?.grade_9_course_array, []);
          const grade10 = checkEnableParseJSON(dataLoaded?.grade_10_course_array, []);
          const grade11 = checkEnableParseJSON(dataLoaded?.grade_11_course_array, []);
          const grade12 = checkEnableParseJSON(dataLoaded?.grade_12_course_array, []);

          setGradeCourse(dataLoaded);
          setGrade9Course(grade9);
          setGrade10Course(grade10);
          setGrade11Course(grade11);
          setGrade12Course(grade12);

          return dataLoaded;
        }
      } catch (error) {
        console.error('Error fetching grade and course data:', error);
      }
    }
    return null;
  };

  console.log('pendingUpdates: ', pendingUpdates);
  
  // Side effects
  React.useEffect(() => {
    getGradeAndCourseFnc();
    setPendingUpdates(true);
  }, []);

  React.useEffect(() => {
    if (props.check && props.indexExpand === props.indexText) {
      setExpanded(true);

      setTimeout(() => {
        if (elementRef.current) {
          elementRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 100);
    } else {
      setExpanded(props.expandAll || false);
    }
  }, [props.expandAll, props.indexExpand, props.check, props.indexText]);

  React.useEffect(() => {
    if (props.item) {
      formItem.resetForm({
        values: {
          ...formItem.values,
          ...props.item,
          start_date: props.item.start_date ?? props.item.startDate,
          end_date: props.item.end_date ?? props.item.endDate,
        },
      });
    }
  }, [props.item?.high_school_name, props.item?.is_graduate_from_this_school, props?.expandAll]);

  React.useEffect(() => {
    if (formItem.dirty) {
      setTimeout(() => {
        props.handleSave({ ...formItem.values });
      }, 500);
    }
  }, [formItem.values]);

  React.useEffect(() => {
    if (!gradingScaleSyncReady.current) {
      gradingScaleSyncReady.current = true;
      return;
    }

    const timer = setTimeout(() => {
      props.handleSave({ ...formItem.values });
    }, 300);

    return () => clearTimeout(timer);
  }, [
    formItem.values.grading_scale_is_abcdf,
    formItem.values.grading_scale_is_0_100,
    formItem.values.grading_scale_is_1_7,
    formItem.values.grading_scale_is_other,
    formItem.values.other_grading_system,
  ]);

  // Update gradeIsNew when grade or related properties change
  React.useEffect(() => {
    // Skip initialization on first render
    if (!isInitialized) {
      return;
    }

    if (formItem.values.gradeIsNew && formItem.values.gradeIsNew.length > 0) {
      // Create a current copy limited to current grade length
      const currentLength = Math.min(
        formItem.values.gradeIsNew.length,
        formItem.values.grade.length
      );

      let updatedGradeIsNew: any = formItem.values.gradeIsNew.slice(0, currentLength);
      let academicYear = formItem.values.academic_year.slice(0, currentLength);

      // Update each grade entry
      formItem.values.grade.forEach((gradeValue, index) => {
        if (index < updatedGradeIsNew.length) {
          // Update existing entries
          updatedGradeIsNew[index] = {
            ...updatedGradeIsNew[index],
            grade: gradeValue,
            academicYear: academicYear[index],
            schoolName: formItem.values.high_school_name,
            grading_scale_is_abcdf: formItem.values.grading_scale_is_abcdf,
            grading_scale_is_0_100: formItem.values.grading_scale_is_0_100,
            grading_scale_is_1_7: formItem.values.grading_scale_is_1_7,
            grading_scale_is_other: formItem.values.grading_scale_is_other,
          };
        } else {
          // Add new entries if needed
          updatedGradeIsNew.push({
            grade: gradeValue,
            isNew: true,
          });
        }
      });

      // Ensure we don't have more entries than grades
      if (updatedGradeIsNew.length > formItem.values.grade.length) {
        updatedGradeIsNew = updatedGradeIsNew.slice(0, formItem.values.grade.length);
      }

      // Only update if changed
      if (JSON.stringify(updatedGradeIsNew) !== JSON.stringify(formItem.values.gradeIsNew)) {
        formItem.setFieldValue('gradeIsNew', updatedGradeIsNew);
      }
    } else if (formItem.values.grade.length > 0) {
      // Initialize gradeIsNew if it doesn't exist
      const initialGradeIsNew = formItem.values.grade.map((gradeValue, index) => ({
        grade: gradeValue,
        isNew: index === formItem.values.grade.length - 1,
      }));
      formItem.setFieldValue('gradeIsNew', initialGradeIsNew);
    }
  }, [
    formItem.values.grade,
    formItem.values.academic_year,
    formItem.values.high_school_name,
    formItem.values.grading_scale_is_abcdf,
    formItem.values.grading_scale_is_0_100,
    formItem.values.grading_scale_is_1_7,
    formItem.values.grading_scale_is_other,
    formItem.values.classes_schedule,
    isInitialized,
  ]);

  const row = props.index + 1;

  return (
    <Card
      className="w-100 my-3 px-0 position-relative overflow"
      style={{ overflow: 'unset' }}
      key={props.indexText}
      ref={elementRef}
    >
      <CardActions
        id={`cardItem${props.index}`}
        disableSpacing
        onClick={handleExpandClick}
        sx={{
          backgroundColor: expanded ? '#AAEBF7' : 'none',
          borderBottom: expanded ? '2px solid #4D88F0' : 'none',
          marginLeft: '-8px',
        }}
      >
        <div className="w-100 d-flex justify-content-between">
          <span
            className="ms-3"
            style={{
              color: formItem.values.high_school_object?.is_manual ? 'black' : '#4d88f0',
            }}
          >
            {buildHeader()}
          </span>
          <strong className="text-field-light">{props.indexText}</strong>
        </div>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          {/* <CardContent className="pr-5 gm-card-content" onClick={(e) => e.stopPropagation()}> */}
          <form id={`SchoolConfig_${props.index}`} onSubmit={formItem.handleSubmit}>
            <Grid container spacing={2} className="gm-form-fields">
              {/* Current/Most Recent High School Checkbox */}
              <Grid xs={12}>
                <CheckboxInput
                  id={`high_school_name${props.index}`}
                  name="isMostRecentHighSchoole"
                  dataUp={`hs-current-school-${row}`}
                  label={'Current or Most Recent High School'}
                  values={props.indexText.slice(0, 1) === '1'}
                  onChange={() => {
                    props.handleCheckCurrent(formItem.values.high_school_name);
                    setExpanded(false);
                  }}
                  disabled={props.disabled}
                />
              </Grid>

              {/* High School Information */}
              <Grid xs={12}>
                <HighSchoolInfo
                  formik={formItem}
                  index={props.index}
                  check={props.check}
                  disabled={props.disabled}
                />
              </Grid>

              {/* Date Inputs */}
              <Grid xs={12} md={6}>
                <DatePickerInput
                  id={`start_date${props.index}`}
                  className="mt-2 justify-content-start"
                  label="Start date*"
                  name="start_date"
                  dataUp={`hs-start-date-${row}`}
                  values={formItem.values.start_date}
                  format="MM/yyyy"
                  onChange={(value) => formItem.setFieldValue('start_date', value)}
                  isMissing={!formItem.values.start_date && props.check}
                  disabled={props.disabled}
                />
                {formItem.errors.start_date && (
                  <div className="text-danger">{formItem.errors.start_date}</div>
                )}
              </Grid>
              <Grid xs={12} md={6}>
                <DatePickerInput
                  id={`end_date${props.index}`}
                  className="mt-2 justify-content-start"
                  name="end_date"
                  label="End date*"
                  dataUp={`hs-end-date-${row}`}
                  values={formItem.values.end_date}
                  format="MM/yyyy"
                  onChange={(value) => {
                    formItem.setFieldValue('end_date', value);
                  }}
                  isMissing={!formItem.values.end_date && props.check}
                  disabled={props.disabled}
                />
                {formItem.errors.end_date && (
                  <div className="text-danger">{formItem.errors.end_date}</div>
                )}
              </Grid>

              {/* High School Attendance Details */}
              {/* <Grid container spacing={2} id="highschool_attend_detail" sx={{ mt: 2 }}>*/}
              <div className="gm-grades-section mt-3" id="highschool_attend_detail">
                <div className="gm-section-subtitle">
                  <p
                    className={`gm-grades-title ${
                      formItem.values.grade.length === 0 ? 'gm-missing-field' : ''
                    }`}
                  >
                    What grades did you attend this high school? *
                  </p>
                </div>

                {/* Grade entries */}
                {formItem.values.grade.map((obj, i) => (
                  <Grid
                    container
                    xs={12}
                    spacing={2}
                    key={i}
                    sx={{ mb: 1, alignItems: 'flex-end' }}
                  >
                    <Grid xs={12} md={5}>
                      <>
                        <SelectInput
                          id={`grade${props.index}_${i}`}
                          form={formItem}
                          option={gradeOptions}
                          label="Grade*"
                          dataUp={`hs-grade-${row}-${i + 1}`}
                          values={formItem.values.grade[i]}
                          name={`grade[${i}]`}
                          onChange={(e) => {
                            formItem.handleChange(e);
                            setPendingUpdates(true);
                          }}
                          isMissing={
                            (!formItem.values.grade[i] ||
                              formItem.values.grade[i] === '- Select -' ||
                              formItem.values.grade[i] === '') &&
                            props.check
                          }
                          disabled={props.disabled}
                        />
                        <span>&nbsp;</span>
                      </>
                    </Grid>
                    <Grid xs={12} md={5}>
                      <SelectInput
                        id={`academic_year${props.index}_${i}`}
                        form={formItem}
                        option={academicYearOptions}
                        label="Academic Year selection *"
                        dataUp={`hs-academic-year-${row}-${i + 1}`}
                        values={formItem.values.academic_year[i]}
                        name={`academic_year[${i}]`}
                        onChange={(e) => {
                          formItem.handleChange(e);
                          setPendingUpdates(true);
                        }}
                        isMissing={
                          (!formItem.values.academic_year[i] ||
                            formItem.values.academic_year[i] === '' ||
                            formItem.values.academic_year[i] === '- Select -') &&
                          props.check
                        }
                        disabled={props.disabled}
                      />
                      <span>&nbsp;</span>
                    </Grid>
                    <Grid xs={12} md={2} sx={{ display: 'flex', alignItems: 'flex-end', pb: 1 }}>
                      <Button
                        variant="danger"
                        className="w-100 my-4"
                        onClick={() => handleRemoveTerm(i)}
                        disabled={props.disabled}
                      >
                        Remove
                      </Button>
                    </Grid>
                    <Grid xs={12}>
                      <CheckboxInput
                        className="pt-0"
                        label="I took summer courses after this grade"
                        name={`is_summer_took[${i}]`}
                        dataUp={`hs-summer-courses-${row}-${i + 1}`}
                        values={formItem.values.is_summer_took[i]}
                        onChange={formItem.handleChange}
                        disabled={props.disabled}
                      />
                    </Grid>
                  </Grid>
                ))}
                {/* </Grid> */}
              </div>

              {/* Add term button - Separate container to ensure consistent centering */}
              {formItem.values.grade.length < 4 && (
                <Grid xs={12} sx={{ mt: 2 }}>
                  <div
                    id={`AddTermYear${props.index}`}
                    className="my-3 w-100 d-flex flex-column align-items-center"
                  >
                    <div className="text-field-light sized70">You can add up to 4 term/year</div>
                    <Button
                      variant="primary"
                      className="p-2 px-5"
                      onClick={handleAddTerm}
                      disabled={props.disabled}
                    >
                      Add another term/year
                    </Button>
                  </div>
                </Grid>
              )}

              {/* Specialized curriculum */}
              <Grid xs={12}>
                <GroupCheckbox
                  columns={2}
                  logo="span-uc-logo"
                  label="Specialized curriculum (if associated with this school)"
                  dataUp={`hs-specialized-curriculum-${row}`}
                  form={formItem}
                  options={[
                    { label: 'Career Pathway/Academy', value: 'specialized_curriculum_career' },
                    {
                      label: 'International Baccalaureate',
                      value: 'specialized_curriculum_international',
                    },
                    { label: 'Magnet', value: 'specialized_curriculum_magnet' },
                    { label: 'Other', value: 'specialized_curriculum_other' },
                  ]}
                  disabled={props.disabled}
                />
              </Grid>
              {formItem.values.specialized_curriculum_other && (
                <Grid xs={12}>
                  <TextInput
                    countText={16}
                    logo="span-uc-logo"
                    label="Other specialized curriculum"
                    name="specialized_curriculum_other_free_text"
                    dataUp={`hs-specialized-curriculum-other-${row}`}
                    values={formItem.values.specialized_curriculum_other_free_text}
                    onChange={formItem.handleChange}
                    disabled={props.disabled}
                  />
                </Grid>
              )}

              {/* Grading Scale Information */}
              <Grid xs={12}>
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography className="fs-6 text-dark my-2 fw-bold">
                        <InfoOutlinedIcon fontSize="small" className="mx-1" />
                        Class Schedule
                      </Typography>
                      <div className="d-flex flex-wrap text-field-light">
                        This one can be tricky, especially if you're on a quarter or trimester
                        system. Please contact your high school counselor to ask how you should
                        complete this section based on your specific high school's recommendation.
                      </div>
                    </React.Fragment>
                  }
                  placement="right-start"
                >
                  <div>
                    <GroupCheckbox
                      columns={2}
                      label="What's this school grading scale?"
                      options={schoolGradingScaleOptions}
                      dataUp={`hs-grading-scale-${row}`}
                      form={formItem}
                      logo="span-uc-logo"
                      disabled={props.disabled}
                    />

                    {/* Numeric Grading Scale Details */}
                    {formItem.values.grading_scale_is_0_100 && (
                      <Grid container spacing={2}>
                        <Grid xs={12} md={6}>
                          <TextInput
                            type="number"
                            label="What is the lowest possible number grade at this school? *"
                            values={formItem.values.lowest_number_grade}
                            dataUp={`hs-lowest-grade-${row}`}
                            name="lowest_number_grade"
                            onChange={formItem.handleChange}
                            feedback={
                              <span className="text-danger">
                                {formItem.errors.lowest_number_grade}
                              </span>
                            }
                            isMissing={!formItem.values.lowest_number_grade && props.check}
                            disabled={props.disabled}
                          />
                        </Grid>
                        <Grid xs={12} md={6}>
                          <TextInput
                            type="number"
                            label="What is the highest possible number grade at this school? *"
                            values={formItem.values.highest_number_grade}
                            dataUp={`hs-highest-grade-${row}`}
                            name="highest_number_grade"
                            onChange={formItem.handleChange}
                            feedback={
                              <span className="text-danger">
                                {formItem.errors.highest_number_grade}
                              </span>
                            }
                            isMissing={!formItem.values.highest_number_grade && props.check}
                            disabled={props.disabled}
                          />
                        </Grid>
                      </Grid>
                    )}

                    {/* Other Grading System — custom numeric range (e.g. UC max 100 vs Common App max 105) */}
                    {formItem.values.grading_scale_is_other && (
                      <Grid xs={12}>
                        <TextInput
                          countText={16}
                          label="Specify grading system *"
                          values={formItem.values.other_grading_system}
                          dataUp={`hs-other-grading-system-${row}`}
                          onChange={formItem.handleChange}
                          name="other_grading_system"
                          isMissing={!formItem.values.other_grading_system && props.check}
                          disabled={props.disabled}
                        />
                      </Grid>
                    )}

                    {/* School System */}
                    <Grid xs={12}>
                      <GroupRadioButton
                        options={classes_schedule_options}
                        name="classes_schedule"
                        values={formItem.values.classes_schedule}
                        dataUp={`hs-school-system-${row}`}
                        onChange={formItem.handleChange}
                        label="What's its school system?*"
                        logo="span-uc-logo"
                        isMissing={!formItem.values.classes_schedule && props.check}
                        verticalLayout={true}
                        disabled={props.disabled}
                      />
                    </Grid>

                    {/* Secondary Grading System */}
                    <Grid xs={12}>
                      <YesNoSwitch
                        className="py-3"
                        label="Does your school have another grading system that has been used while you have attended?"
                        name="have_other_grading_system"
                        dataUp={`hs-other-grading-used-${row}`}
                        values={formItem.values.have_other_grading_system}
                        onChange={formItem.handleChange}
                        disabled={props.disabled}
                      />
                    </Grid>
                    {formItem.values.have_other_grading_system === 'true' && (
                      <>
                        <Grid xs={12}>
                          <GroupRadioButton
                            label="What is the second school system?"
                            name="second_grading_system"
                            dataUp={`hs-second-school-system-${row}`}
                            values={formItem.values.second_grading_system}
                            onChange={formItem.handleChange}
                            options={classes_schedule_options}
                            verticalLayout={true}
                            disabled={props.disabled}
                          />
                        </Grid>
                        <Grid xs={12}>
                          <div className="text-field-light mb-3">
                            When entering your courses and grades in each grade year, add your high
                            school twice and select the school system before entering in your
                            grades.
                          </div>
                        </Grid>
                      </>
                    )}
                  </div>
                </HtmlTooltip>
              </Grid>

              {/* School Type Questions */}
              <Grid xs={12} sx={{ paddingTop: '16px', paddingBottom: '0' }}>
                <div className="text-dark fs-5 p-1 fw-bold">School Type Questions</div>
              </Grid>
              <Grid xs={12} md={6}>
                <YesNoSwitch
                  className="py-8"
                  label="Is this a boarding school?*"
                  name="is_boarding_school"
                  dataUp={`hs-boarding-school-${row}`}
                  values={formItem.values.is_boarding_school}
                  onChange={formItem.handleChange}
                  isMissing={!formItem.values.is_boarding_school && props.check}
                  disabled={props.disabled}
                />
              </Grid>
              <Grid xs={12} md={6}>
                <YesNoSwitch
                  className="py-8 "
                  label="Do you live on campus?"
                  name="is_live_on_campus"
                  dataUp={`hs-live-on-campus-${row}`}
                  values={formItem.values.is_live_on_campus}
                  onChange={formItem.handleChange}
                  isMissing={!formItem.values.is_live_on_campus && props.check}
                  disabled={props.disabled}
                />
              </Grid>
              <Grid xs={12}>
                <YesNoSwitch
                  className="py-8"
                  label="Did or will you graduate from this school?*"
                  name="is_graduate_from_this_school"
                  dataUp={`hs-graduate-here-${row}`}
                  values={formItem.values.is_graduate_from_this_school}
                  onChange={formItem.handleChange}
                  isMissing={!formItem.values.is_graduate_from_this_school && props.check}
                  disabled={props.disabled}
                />
              </Grid>

              {formItem.values.is_graduate_from_this_school === 'true' && (
                <>
                  <Grid xs={12}>
                    <div className="border my-3 w-100" />
                  </Grid>
                  <Grid xs={12}>
                    <div>Graduation Details</div>
                  </Grid>
                  <Grid xs={12}>
                    <SelectInput
                      form={formItem}
                      dataUp={`hs-degree-${row}`}
                      option={[
                        { value: '', name: '- Select -' },
                        {
                          value: 'No degree from this high school',
                          name: 'No degree from this high school',
                        },
                        {
                          value: 'High School/Secondary School Diploma',
                          name: 'High School/Secondary School Diploma',
                        },
                        { value: 'IB Diploma', name: 'IB Diploma' },
                        { value: 'GED', name: 'GED' },
                        { value: 'Certificate of Proficiency', name: 'Certificate of Proficiency' },
                        { value: 'Other', name: 'Other' },
                      ]}
                      label="Degree, diploma, or certification received or to be received. *"
                      values={formItem.values.degree}
                      name="degree"
                      onChange={(e) => {
                        console.log('degree e:', e);
                        formItem.setFieldValue('degree', e.target.value);
                      }}
                      isMissing={!formItem.values.degree && props.check}
                      disabled={props.disabled}
                    />
                  </Grid>
                  {formItem.values.degree === 'Other' && (
                    <Grid xs={12}>
                      <TextInput
                        countText={32}
                        label="Other"
                        name="degreeFreeText"
                        dataUp={`hs-degree-other-${row}`}
                        values={formItem.values.degreeFreeText}
                        onChange={formItem.handleChange}
                        disabled={props.disabled}
                      />
                    </Grid>
                  )}
                  {formItem.values.degree !== 'No degree from this high school' && (
                    <Grid xs={12}>
                      <DateReceiveInfo
                        formik={formItem}
                        check={props.check}
                        disabled={props.disabled}
                        row={row}
                      />
                    </Grid>
                  )}
                </>
              )}

              {/* Save Button */}
              <Grid xs={12}>
                <div className="border w-100 my-3" />
              </Grid>
              <Grid xs={12} className="d-flex justify-content-end">
                <Button className="p-3" onClick={handleSave} disabled={props.disabled}>
                  Add/Update High School to Grade
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Collapse>
      <RemoveCircleOutlineIcon
        className="position-absolute text-field-light pointer"
        style={{
          right: '-24px',
          top: '12px',
          opacity: props.disabled ? 0.5 : 1,
          cursor: props.disabled ? 'not-allowed' : 'pointer',
        }}
        onClick={props.disabled ? undefined : props.onRemove}
      />
    </Card>
  );
};

export default SchoolConfig;
